import styled from "styled-components";
import colors from "../../constants/colors";
import { Subtitle, Title } from "../styles";

export const BusinessName = styled(Title)({
  fontSize: "36px",
  margin: 0,
});

export const OwnerName = styled(Subtitle)({
  fontSize: "20px",
  margin: "0 0 2rem 0",
});

export const ImageWrapper = styled("div")({
  width: "100%",
  marginBlock: "1rem",
  img: {
    width: "100%",
    borderRadius: "10px",
    border: `1px solid ${colors.GREY_2}`,
  },
});

export const Banner = styled("div")({
  width: "100%",
  padding: "0.75rem 1rem",
  marginBottom: "1rem",
  backgroundColor: colors.PURPLE,
  color: "#ffffff",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: 600,
  textAlign: "center",
  "&:hover": {
    opacity: 0.9,
  },
});

export const ManageAppointmentLink = styled("button")({
  background: "none",
  border: "none",
  padding: "1rem 0.5rem",
  marginTop: "0.5rem",
  color: colors.PURPLE,
  fontSize: "0.95rem",
  cursor: "pointer",
  textDecoration: "underline",
  "&:hover": {
    opacity: 0.8,
  },
});
